export default {
  on: true,
  cache: true,
  auth: true,
  intercept: false,

  title: '任务单详情',
  dynamicParam: '/:id/:deliveryTaskFormNo',
} as TCommon.RouteConfig
